import { getAdminInvoicingBackfillsRetrieveQueryOptions } from "@sidegigllc/api/client";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { backfillId: number };

export const backfillQuery = ({ backfillId }: QueriesInput) =>
  getAdminInvoicingBackfillsRetrieveQueryOptions(backfillId, { query: { enabled: backfillId > 0 } });

export const queries = (input: QueriesInput): Array<WarmableQuery> => [backfillQuery(input)];
